import { EntityEnums } from "../enums";

export const moodVariantsDict = [
  {
    value: EntityEnums.MoodVariant.Realis,
    label: "realis",
    info: "",
  },
  {
    value: EntityEnums.MoodVariant.Irrealis,
    label: "irrealis",
    info: "",
  },
  {
    value: EntityEnums.MoodVariant.ToBeDecided,
    label: "to be decided",
    info: "",
  },
];
